import { Container } from 'src/components/Container';
import { Team } from '../events/components/Team';

export const TeamDetail = () => {
  return (
    <Container>
      <Team />
    </Container>
  );
}